import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const SmartSubscriptionRoot = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '64px 16px',

  '@bp2': {
    padding: '48px',
  },
})

export const Header = styled('h2', {
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  width: '100%',
  maxWidth: '360px',
  textAlign: 'center',
  marginBottom: '32px',

  '@bp2': {
    maxWidth: '1300px',
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
    marginBottom: '32px',
  },
})

export const Description = styled(Text, {
  width: '100%',
  maxWidth: '360px',
  textAlign: 'center',
  marginBottom: '32px',

  '@bp1': {
    maxWidth: '800px',
    marginBottom: '32px',
  },
})

export const ListContainer = styled('div', {
  width: '100%',
  maxWidth: '1000px',
  marginBottom: '32px',

  '@bp2': {
    marginBottom: '32px',
  },
})

export const BenefitContainer = styled('div', {})

export const IconContainer = styled('div', {
  display: 'block',
  width: '100%',
  textAlign: 'center',
  padding: '0px 0px 20px',

  '@bp1': {
    display: 'none',
  },
})